import mixpanel from 'mixpanel-browser';
import { supabase } from '@/integrations/supabase/client';

const MIXPANEL_TOKEN = 'b64773ee30ab52612bde2a49525fd686';

let initialized = false;

export function initAnalytics() {
  if (initialized) return;
  initialized = true;

  mixpanel.init(MIXPANEL_TOKEN, {
    autocapture: true,
    track_pageview: true,
    persistence: 'localStorage',
    record_sessions_percent: 100,
  });

  // Keep Mixpanel distinct_id aligned with auth user when available
  supabase.auth.getUser().then(({ data }) => {
    const user = data.user;
    if (user?.id) {
      mixpanel.identify(user.id);
      if (user.email) mixpanel.people.set({ $email: user.email });
    }
  });
}

export function track(event: string, props?: Record<string, unknown>) {
  if (!initialized) initAnalytics();
  try {
    mixpanel.track(event, props);
  } catch {
    // ignore
  }
}

export async function identifyCurrentUser(extraProps?: Record<string, unknown>) {
  if (!initialized) initAnalytics();
  const { data } = await supabase.auth.getUser();
  const user = data.user;
  if (!user?.id) return;

  mixpanel.identify(user.id);
  mixpanel.people.set({
    ...(user.email ? { $email: user.email } : {}),
    ...(extraProps ?? {}),
  });
}
